export const cvdcalculation = {
  "male": {
    "non-smoker": {
      "70-74": {
        "180": {
          "19": {
            "color": "red",
            "value": "26",
          },
          "20-24": {
            "color": "red",
            "value": "27",
          },
          "25-29": {
            "color": "red",
            "value": "29",
          },
          "30-34": {
            "color": "maroon",
            "value": "30",
          },
          "35": {
            "color": "maroon",
            "value": "32",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "23",
          },
          "25-29": {
            "color": "red",
            "value": "24",
          },
          "30-34": {
            "color": "red",
            "value": "25",
          },
          "35": {
            "color": "red",
            "value": "27",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "18",
          },
          "20-24": {
            "color": "orange",
            "value": "19",
          },
          "25-29": {
            "color": "red",
            "value": "20",
          },
          "30-34": {
            "color": "red",
            "value": "21",
          },
          "35": {
            "color": "red",
            "value": "23",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "18",
          },
          "35": {
            "color": "orange",
            "value": "19",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "13",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "14",
          },
          "30-34": {
            "color": "orange",
            "value": "15",
          },
          "35": {
            "color": "orange",
            "value": "16",
          },
        },
      },
      "65-69": {
        "180": {
          "19": {
            "color": "red",
            "value": "21",
          },
          "20-24": {
            "color": "red",
            "value": "22",
          },
          "25-29": {
            "color": "red",
            "value": "24",
          },
          "30-34": {
            "color": "red",
            "value": "25",
          },
          "35": {
            "color": "red",
            "value": "27",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "17",
          },
          "20-24": {
            "color": "orange",
            "value": "18",
          },
          "25-29": {
            "color": "orange",
            "value": "19",
          },
          "30-34": {
            "color": "red",
            "value": "21",
          },
          "35": {
            "color": "red",
            "value": "22",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "14",
          },
          "20-24": {
            "color": "orange",
            "value": "15",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "18",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "11",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
      },
      "60-64": {
        "180": {
          "19": {
            "color": "orange",
            "value": "17",
          },
          "20-24": {
            "color": "orange",
            "value": "18",
          },
          "25-29": {
            "color": "orange",
            "value": "19",
          },
          "30-34": {
            "color": "red",
            "value": "21",
          },
          "35": {
            "color": "red",
            "value": "23",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "13",
          },
          "20-24": {
            "color": "orange",
            "value": "14",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "18",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "11",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "12",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "9",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "7",
          },
          "20-24": {
            "color": "yellow",
            "value": "7",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "9",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        },
      },
      "55-59": {
        "180": {
          "19": {
            "color": "orange",
            "value": "14",
          },
          "20-24": {
            "color": "orange",
            "value": "15",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "19",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "11",
          },
          "20-24": {
            "color": "orange",
            "value": "11",
          },
          "25-29": {
            "color": "orange",
            "value": "12",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "9",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "7",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "5",
          },
          "20-24": {
            "color": "yellow",
            "value": "5",
          },
          "25-29": {
            "color": "yellow",
            "value": "6",
          },
          "30-34": {
            "color": "yellow",
            "value": "6",
          },
          "35": {
            "color": "yellow",
            "value": "7",
          },
        },
      },
      "50-54": {
        "180": {
          "19": {
            "color": "orange",
            "value": "11",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "16",
          },
        },
        "160-179": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "9",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "7",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "5",
          },
          "20-24": {
            "color": "yellow",
            "value": "5",
          },
          "25-29": {
            "color": "yellow",
            "value": "6",
          },
          "30-34": {
            "color": "yellow",
            "value": "6",
          },
          "35": {
            "color": "yellow",
            "value": "7",
          },
        },
        "119": {
          "19": {
            "color": "green",
            "value": "4",
          },
          "20-24": {
            "color": "green",
            "value": "4",
          },
          "25-29": {
            "color": "green",
            "value": "4",
          },
          "30-34": {
            "color": "yellow",
            "value": "5",
          },
          "35": {
            "color": "yellow",
            "value": "5",
          },
        }
      },
        "45-49": {
          "180": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "11",
            },
            "30-34": {
              "color": "orange",
              "value": "12",
            },
            "35": {
              "color": "orange",
              "value": "13",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "9",
            },
            "35": {
              "color": "orange",
              "value": "10",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "7",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
          "120-139": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "green",
              "value": "4",
            },
            "30-34": {
              "color": "yellow",
              "value": "5",
            },
            "35": {
              "color": "yellow",
              "value": "6",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "3",
            },
            "25-29": {
              "color": "green",
              "value": "3",
            },
            "30-34": {
              "color": "green",
              "value": "4",
            },
            "35": {
              "color": "green",
              "value": "4",
            },
          },
        },
        "40-44": {
          "180": {
            "19": {
              "color": "yellow",
              "value": "7",
            },
            "20-24": {
              "color": "yellow",
              "value": "8",
            },
            "25-29": {
              "color": "yellow",
              "value": "9",
            },
            "30-34": {
              "color": "orange",
              "value": "10",
            },
            "35": {
              "color": "orange",
              "value": "11",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "6",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "7",
            },
            "35": {
              "color": "yellow",
              "value": "8",
            },
          },
          "140-159": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "orange",
              "value": "5",
            },
            "30-34": {
              "color": "orange",
              "value": "5",
            },
            "35": {
              "color": "orange",
              "value": "6",
            },
          },
          "120-139": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "3",
            },
            "25-29": {
              "color": "green",
              "value": "3",
            },
            "30-34": {
              "color": "green",
              "value": "4",
            },
            "35": {
              "color": "green",
              "value": "4",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "2",
            },
            "20-24": {
              "color": "green",
              "value": "2",
            },
            "25-29": {
              "color": "green",
              "value": "2",
            },
            "30-34": {
              "color": "green",
              "value": "3",
            },
            "35": {
              "color": "green",
              "value": "3",
            },
          },
        },
      },
    "smoker": {
      "70-74": {
        "180": {
          "19": {
            "color": "maroon",
            "value": "32",
          },
          "20-24": {
            "color": "maroon",
            "value": "33",
          },
          "25-29": {
            "color": "maroon",
            "value": "35",
          },
          "30-34": {
            "color": "maroon",
            "value": "37",
          },
          "35": {
            "color": "maroon",
            "value": "38",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "27",
          },
          "20-24": {
            "color": "red",
            "value": "28",
          },
          "25-29": {
            "color": "maroon",
            "value": "30",
          },
          "30-34": {
            "color": "maroon",
            "value": "31",
          },
          "35": {
            "color": "maroon",
            "value": "33",
          },
        },
        "140-159": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "24",
          },
          "25-29": {
            "color": "red",
            "value": "25",
          },
          "30-34": {
            "color": "red",
            "value": "26",
          },
          "35": {
            "color": "red",
            "value": "28",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "19",
          },
          "20-24": {
            "color": "red",
            "value": "20",
          },
          "25-29": {
            "color": "red",
            "value": "21",
          },
          "30-34": {
            "color": "red",
            "value": "22",
          },
          "35": {
            "color": "red",
            "value": "23",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "16",
          },
          "20-24": {
            "color": "orange",
            "value": "17",
          },
          "25-29": {
            "color": "orange",
            "value": "18",
          },
          "30-34": {
            "color": "orange",
            "value": "19",
          },
          "35": {
            "color": "red",
            "value": "20",
          },
        },
      },
      "65-69": {
        "180": {
          "19": {
            "color": "red",
            "value": "27",
          },
          "20-24": {
            "color": "red",
            "value": "29",
          },
          "25-29": {
            "color": "maroon",
            "value": "31",
          },
          "30-34": {
            "color": "maroon",
            "value": "33",
          },
          "35": {
            "color": "maroon",
            "value": "35",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "24",
          },
          "25-29": {
            "color": "red",
            "value": "25",
          },
          "30-34": {
            "color": "red",
            "value": "27",
          },
          "35": {
            "color": "red",
            "value": "29",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "18",
          },
          "20-24": {
            "color": "red",
            "value": "20",
          },
          "25-29": {
            "color": "red",
            "value": "21",
          },
          "30-34": {
            "color": "red",
            "value": "22",
          },
          "35": {
            "color": "red",
            "value": "24",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "18",
          },
          "35": {
            "color": "red",
            "value": "20",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "14",
          },
          "30-34": {
            "color": "orange",
            "value": "15",
          },
          "35": {
            "color": "orange",
            "value": "16",
          },
        },
      },
      "60-64": {
        "180": {
          "19": {
            "color": "red",
            "value": "23",
          },
          "20-24": {
            "color": "red",
            "value": "25",
          },
          "25-29": {
            "color": "red",
            "value": "27",
          },
          "30-34": {
            "color": "red",
            "value": "29",
          },
          "35": {
            "color": "maroon",
            "value": "31",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "19",
          },
          "20-24": {
            "color": "red",
            "value": "20",
          },
          "25-29": {
            "color": "red",
            "value": "22",
          },
          "30-34": {
            "color": "red",
            "value": "23",
          },
          "35": {
            "color": "red",
            "value": "25",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "19",
          },
          "35": {
            "color": "red",
            "value": "21",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "14",
          },
          "30-34": {
            "color": "orange",
            "value": "15",
          },
          "35": {
            "color": "orange",
            "value": "17",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "12",
          },
          "35": {
            "color": "orange",
            "value": "13",
          },
        },
      },
      "55-59": {
        "180": {
          "19": {
            "color": "red",
            "value": "20",
          },
          "20-24": {
            "color": "red",
            "value": "21",
          },
          "25-29": {
            "color": "red",
            "value": "23",
          },
          "30-34": {
            "color": "red",
            "value": "26",
          },
          "35": {
            "color": "red",
            "value": "28",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "17",
          },
          "25-29": {
            "color": "orange",
            "value": "18",
          },
          "30-34": {
            "color": "red",
            "value": "20",
          },
          "35": {
            "color": "red",
            "value": "22",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "12",
          },
          "20-24": {
            "color": "yellow",
            "value": "13",
          },
          "25-29": {
            "color": "yellow",
            "value": "15",
          },
          "30-34": {
            "color": "yellow",
            "value": "16",
          },
          "35": {
            "color": "yellow",
            "value": "18",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "14",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "7",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "9",
          },
          "30-34": {
            "color": "orange",
            "value": "10",
          },
          "35": {
            "color": "orange",
            "value": "11",
          },
        },
      },
      "50-54": {
        "180": {
          "19": {
            "color": "orange",
            "value": "17",
          },
          "20-24": {
            "color": "orange",
            "value": "18",
          },
          "25-29": {
            "color": "red",
            "value": "20",
          },
          "30-34": {
            "color": "red",
            "value": "23",
          },
          "35": {
            "color": "red",
            "value": "25",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "13",
          },
          "20-24": {
            "color": "orange",
            "value": "14",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "19",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "11",
          },
          "25-29": {
            "color": "orange",
            "value": "12",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "7",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "9",
          },
          "30-34": {
            "color": "orange",
            "value": "10",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "6",
          },
          "25-29": {
            "color": "yellow",
            "value": "7",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        }
      },
      "45-49": {
          "180": {
            "19": {
              "color": "orange",
              "value": "14",
            },
            "20-24": {
              "color": "orange",
              "value": "16",
            },
            "25-29": {
              "color": "orange",
              "value": "18",
            },
            "30-34": {
              "color": "red",
              "value": "20",
            },
            "35": {
              "color": "red",
              "value": "22",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "12",
            },
            "25-29": {
              "color": "orange",
              "value": "13",
            },
            "30-34": {
              "color": "orange",
              "value": "15",
            },
            "35": {
              "color": "orange",
              "value": "17",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "9",
            },
            "25-29": {
              "color": "orange",
              "value": "10",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "13",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "7",
            },
            "30-34": {
              "color": "yellow",
              "value": "8",
            },
            "35": {
              "color": "yellow",
              "value": "10",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
         },
        "40-44": {
          "180": {
            "19": {
              "color": "orange",
              "value": "12",
            },
            "20-24": {
              "color": "orange",
              "value": "13",
            },
            "25-29": {
              "color": "orange",
              "value": "15",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "red",
              "value": "20",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "11",
            },
            "30-34": {
              "color": "orange",
              "value": "13",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "9",
            },
            "35": {
              "color": "orange",
              "value": "11",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "7",
            },
            "35": {
              "color": "yellow",
              "value": "8",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "green",
              "value": "4",
            },
            "30-34": {
              "color": "yellow",
              "value": "5",
            },
            "35": {
              "color": "yellow",
              "value": "6",
            },
          },
        },
      },
      "40-44": {
        "180": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "15",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "red",
            "value": "20",
          },
        },
        "160-179": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "7",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "9",
          },
          "35": {
            "color": "orange",
            "value": "11",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "5",
          },
          "20-24": {
            "color": "yellow",
            "value": "5",
          },
          "25-29": {
            "color": "yellow",
            "value": "6",
          },
          "30-34": {
            "color": "yellow",
            "value": "7",
          },
          "35": {
            "color": "yellow",
            "value": "8",
          },
        },
        "119": {
          "19": {
            "color": "green",
            "value": "3",
          },
          "20-24": {
            "color": "green",
            "value": "4",
          },
          "25-29": {
            "color": "green",
            "value": "4",
          },
          "30-34": {
            "color": "yellow",
            "value": "5",
          },
          "35": {
            "color": "yellow",
            "value": "6",
          },
        },
    },
  },
  "female": {
    "non-smoker": {
      "70-74": {
        "180": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "23",
          },
          "25-29": {
            "color": "red",
            "value": "23",
          },
          "30-34": {
            "color": "red",
            "value": "24",
          },
          "35": {
            "color": "red",
            "value": "25",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "19",
          },
          "20-24": {
            "color": "red",
            "value": "20",
          },
          "25-29": {
            "color": "red",
            "value": "20",
          },
          "30-34": {
            "color": "red",
            "value": "21",
          },
          "35": {
            "color": "red",
            "value": "21",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "16",
          },
          "20-24": {
            "color": "orange",
            "value": "17",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "18",
          },
          "35": {
            "color": "orange",
            "value": "18",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "14",
          },
          "20-24": {
            "color": "orange",
            "value": "14",
          },
          "25-29": {
            "color": "orange",
            "value": "14",
          },
          "30-34": {
            "color": "orange",
            "value": "15",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "12",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "13",
          },
        },
      },
      "65-69": {
        "180": {
          "19": {
            "color": "orange",
            "value": "18",
          },
          "20-24": {
            "color": "orange",
            "value": "19",
          },
          "25-29": {
            "color": "orange",
            "value": "19",
          },
          "30-34": {
            "color": "red",
            "value": "20",
          },
          "35": {
            "color": "red",
            "value": "20",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "15",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "16",
          },
          "35": {
            "color": "orange",
            "value": "17",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "14",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "11",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "9",
          },
          "25-29": {
            "color": "yellow",
            "value": "9",
          },
          "30-34": {
            "color": "yellow",
            "value": "9",
          },
          "35": {
            "color": "orange",
            "value": "10",
          },
        },
      },
      "60-64": {
        "180": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "15",
          },
          "25-29": {
            "color": "orange",
            "value": "15",
          },
          "30-34": {
            "color": "orange",
            "value": "16",
          },
          "35": {
            "color": "orange",
            "value": "17",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "13",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "10",
          },
          "35": {
            "color": "orange",
            "value": "11",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "6",
          },
          "25-29": {
            "color": "yellow",
            "value": "7",
          },
          "30-34": {
            "color": "yellow",
            "value": "7",
          },
          "35": {
            "color": "yellow",
            "value": "7",
          },
        },
      },
      "55-59": {
        "180": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "12",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "13",
          },
          "35": {
            "color": "orange",
            "value": "13",
          },
        },
        "160-179": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "10",
          },
          "35": {
            "color": "orange",
            "value": "11",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "7",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "8",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "6",
          },
          "25-29": {
            "color": "yellow",
            "value": "6",
          },
          "30-34": {
            "color": "yellow",
            "value": "6",
          },
          "35": {
            "color": "yellow",
            "value": "7",
          },
        },
        "119": {
          "19": {
            "color": "green",
            "value": "4",
          },
          "20-24": {
            "color": "yellow",
            "value": "5",
          },
          "25-29": {
            "color": "yellow",
            "value": "5",
          },
          "30-34": {
            "color": "yellow",
            "value": "5",
          },
          "35": {
            "color": "yellow",
            "value": "5",
          },
        },
      },
      "50-54": {
        "180": {
          "19": {
            "color": "yellow",
            "value": "9",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "10",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "11",
          },
        },
        "160-179": {
          "19": {
            "color": "yellow",
            "value": "7",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "8",
          },
          "35": {
            "color": "yellow",
            "value": "8",
          },
        },
        "140-159": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "6",
          },
          "25-29": {
            "color": "yellow",
            "value": "6",
          },
          "30-34": {
            "color": "yellow",
            "value": "6",
          },
          "35": {
            "color": "yellow",
            "value": "6",
          },
        },
        "120-139": {
          "19": {
            "color": "green",
            "value": "4",
          },
          "20-24": {
            "color": "green",
            "value": "4",
          },
          "25-29": {
            "color": "yellow",
            "value": "5",
          },
          "30-34": {
            "color": "yellow",
            "value": "5",
          },
          "35": {
            "color": "yellow",
            "value": "5",
          },
        },
        "119": {
          "19": {
            "color": "green",
            "value": "3",
          },
          "20-24": {
            "color": "green",
            "value": "3",
          },
          "25-29": {
            "color": "green",
            "value": "3",
          },
          "30-34": {
            "color": "green",
            "value": "4",
          },
          "35": {
            "color": "green",
            "value": "4",
          },
        }
    },
        "45-49": {
          "180": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "8",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "9",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "6",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
          "140-159": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "yellow",
              "value": "5",
            },
            "30-34": {
              "color": "yellow",
              "value": "5",
            },
            "35": {
              "color": "yellow",
              "value": "5",
            },
          },
          "120-139": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "3",
            },
            "25-29": {
              "color": "green",
              "value": "3",
            },
            "30-34": {
              "color": "green",
              "value": "4",
            },
            "35": {
              "color": "green",
              "value": "4",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "2",
            },
            "20-24": {
              "color": "green",
              "value": "2",
            },
            "25-29": {
              "color": "green",
              "value": "2",
            },
            "30-34": {
              "color": "green",
              "value": "3",
            },
            "35": {
              "color": "green",
              "value": "3",
            },
          },
        },
        "40-44": {
          "180": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "6",
            },
            "25-29": {
              "color": "yellow",
              "value": "7",
            },
            "30-34": {
              "color": "yellow",
              "value": "7",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
          "160-179": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "5",
            },
            "30-34": {
              "color": "yellow",
              "value": "5",
            },
            "35": {
              "color": "yellow",
              "value": "5",
            },
          },
          "140-159": {
            "19": {
              "color": "green",
              "value": "3",
            },
            "20-24": {
              "color": "green",
              "value": "3",
            },
            "25-29": {
              "color": "green",
              "value": "4",
            },
            "30-34": {
              "color": "green",
              "value": "4",
            },
            "35": {
              "color": "green",
              "value": "4",
            },
          },
          "120-139": {
            "19": {
              "color": "green",
              "value": "2",
            },
            "20-24": {
              "color": "green",
              "value": "2",
            },
            "25-29": {
              "color": "green",
              "value": "3",
            },
            "30-34": {
              "color": "green",
              "value": "3",
            },
            "35": {
              "color": "green",
              "value": "3",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "2",
            },
            "20-24": {
              "color": "green",
              "value": "2",
            },
            "25-29": {
              "color": "green",
              "value": "2",
            },
            "30-34": {
              "color": "green",
              "value": "2",
            },
            "35": {
              "color": "green",
              "value": "2",
            },
          },
        },
      },
    "smoker": {
      "70-74": {
        "180": {
          "19": {
            "color": "maroon",
            "value": "30",
          },
          "20-24": {
            "color": "maroon",
            "value": "31",
          },
          "25-29": {
            "color": "maroon",
            "value": "32",
          },
          "30-34": {
            "color": "maroon",
            "value": "32",
          },
          "35": {
            "color": "maroon",
            "value": "33",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "26",
          },
          "20-24": {
            "color": "red",
            "value": "26",
          },
          "25-29": {
            "color": "red",
            "value": "27",
          },
          "30-34": {
            "color": "red",
            "value": "28",
          },
          "35": {
            "color": "red",
            "value": "29",
          },
        },
        "140-159": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "23",
          },
          "25-29": {
            "color": "red",
            "value": "23",
          },
          "30-34": {
            "color": "red",
            "value": "24",
          },
          "35": {
            "color": "red",
            "value": "25",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "19",
          },
          "20-24": {
            "color": "orange",
            "value": "19",
          },
          "25-29": {
            "color": "red",
            "value": "20",
          },
          "30-34": {
            "color": "red",
            "value": "20",
          },
          "35": {
            "color": "red",
            "value": "21",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "16",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "18",
          },
        },
      },
      "65-69": {
        "180": {
          "19": {
            "color": "red",
            "value": "26",
          },
          "20-24": {
            "color": "red",
            "value": "27",
          },
          "25-29": {
            "color": "red",
            "value": "28",
          },
          "30-34": {
            "color": "red",
            "value": "29",
          },
          "35": {
            "color": "maroon",
            "value": "30",
          },
        },
        "160-179": {
          "19": {
            "color": "red",
            "value": "22",
          },
          "20-24": {
            "color": "red",
            "value": "23",
          },
          "25-29": {
            "color": "red",
            "value": "23",
          },
          "30-34": {
            "color": "red",
            "value": "24",
          },
          "35": {
            "color": "red",
            "value": "25",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "18",
          },
          "20-24": {
            "color": "orange",
            "value": "19",
          },
          "25-29": {
            "color": "orange",
            "value": "19",
          },
          "30-34": {
            "color": "red",
            "value": "20",
          },
          "35": {
            "color": "red",
            "value": "21",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "17",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "13",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "14",
          },
        },
      },
      "60-64": {
        "180": {
          "19": {
            "color": "red",
            "value": "23",
          },
          "20-24": {
            "color": "red",
            "value": "23",
          },
          "25-29": {
            "color": "red",
            "value": "24",
          },
          "30-34": {
            "color": "red",
            "value": "25",
          },
          "35": {
            "color": "red",
            "value": "26",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "18",
          },
          "20-24": {
            "color": "orange",
            "value": "19",
          },
          "25-29": {
            "color": "red",
            "value": "20",
          },
          "30-34": {
            "color": "red",
            "value": "21",
          },
          "35": {
            "color": "red",
            "value": "21",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "15",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "16",
          },
          "30-34": {
            "color": "orange",
            "value": "17",
          },
          "35": {
            "color": "orange",
            "value": "17",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "14",
          },
        },
        "119": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
      },
      "55-59": {
        "180": {
          "19": {
            "color": "red",
            "value": "20",
          },
          "20-24": {
            "color": "red",
            "value": "20",
          },
          "25-29": {
            "color": "red",
            "value": "21",
          },
          "30-34": {
            "color": "red",
            "value": "22",
          },
          "35": {
            "color": "red",
            "value": "23",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "16",
          },
          "20-24": {
            "color": "orange",
            "value": "16",
          },
          "25-29": {
            "color": "orange",
            "value": "17",
          },
          "30-34": {
            "color": "orange",
            "value": "18",
          },
          "35": {
            "color": "orange",
            "value": "18",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "12",
          },
          "20-24": {
            "color": "orange",
            "value": "13",
          },
          "25-29": {
            "color": "orange",
            "value": "13",
          },
          "30-34": {
            "color": "orange",
            "value": "14",
          },
          "35": {
            "color": "orange",
            "value": "15",
          },
        },
        "120-139": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "10",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "11",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "8",
          },
          "30-34": {
            "color": "yellow",
            "value": "9",
          },
          "35": {
            "color": "yellow",
            "value": "9",
          },
        },
      },
      "50-54": {
        "180": {
          "19": {
            "color": "orange",
            "value": "17",
          },
          "20-24": {
            "color": "orange",
            "value": "18",
          },
          "25-29": {
            "color": "orange",
            "value": "18",
          },
          "30-34": {
            "color": "orange",
            "value": "19",
          },
          "35": {
            "color": "red",
            "value": "20",
          },
        },
        "160-179": {
          "19": {
            "color": "orange",
            "value": "13",
          },
          "20-24": {
            "color": "orange",
            "value": "14",
          },
          "25-29": {
            "color": "orange",
            "value": "14",
          },
          "30-34": {
            "color": "orange",
            "value": "15",
          },
          "35": {
            "color": "orange",
            "value": "16",
          },
        },
        "140-159": {
          "19": {
            "color": "orange",
            "value": "10",
          },
          "20-24": {
            "color": "orange",
            "value": "11",
          },
          "25-29": {
            "color": "orange",
            "value": "11",
          },
          "30-34": {
            "color": "orange",
            "value": "12",
          },
          "35": {
            "color": "orange",
            "value": "12",
          },
        },
        "120-139": {
          "19": {
            "color": "yellow",
            "value": "8",
          },
          "20-24": {
            "color": "yellow",
            "value": "8",
          },
          "25-29": {
            "color": "yellow",
            "value": "9",
          },
          "30-34": {
            "color": "yellow",
            "value": "9",
          },
          "35": {
            "color": "orange",
            "value": "10",
          },
        },
        "119": {
          "19": {
            "color": "yellow",
            "value": "6",
          },
          "20-24": {
            "color": "yellow",
            "value": "6",
          },
          "25-29": {
            "color": "yellow",
            "value": "7",
          },
          "30-34": {
            "color": "yellow",
            "value": "7",
          },
          "35": {
            "color": "yellow",
            "value": "7",
          },
        }
    },
        "45-49": {
          "180": {
            "19": {
              "color": "orange",
              "value": "15",
            },
            "20-24": {
              "color": "orange",
              "value": "15",
            },
            "25-29": {
              "color": "orange",
              "value": "16",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "orange",
              "value": "18",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "12",
            },
            "25-29": {
              "color": "orange",
              "value": "12",
            },
            "30-34": {
              "color": "orange",
              "value": "13",
            },
            "35": {
              "color": "orange",
              "value": "13",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "9",
            },
            "25-29": {
              "color": "yellow",
              "value": "9",
            },
            "30-34": {
              "color": "orange",
              "value": "10",
            },
            "35": {
              "color": "orange",
              "value": "10",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "7",
            },
            "30-34": {
              "color": "yellow",
              "value": "7",
            },
            "35": {
              "color": "yellow",
              "value": "8",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "5",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "6",
            },
          },
        },
        "40-44": {
          "180": {
            "19": {
              "color": "orange",
              "value": "13",
            },
            "20-24": {
              "color": "orange",
              "value": "13",
            },
            "25-29": {
              "color": "orange",
              "value": "14",
            },
            "30-34": {
              "color": "orange",
              "value": "15",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "10",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "7",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "8",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "6",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "green",
              "value": "4",
            },
            "30-34": {
              "color": "green",
              "value": "4",
            },
            "35": {
              "color": "yellow",
              "value": "5",
            },
          },
        }
      }
    },
    // Currently calculation is same for "Other" as it is for "Male"
  "other": {
      "non-smoker": {
        "70-74": {
          "180": {
            "19": {
              "color": "red",
              "value": "26",
            },
            "20-24": {
              "color": "red",
              "value": "27",
            },
            "25-29": {
              "color": "red",
              "value": "29",
            },
            "30-34": {
              "color": "maroon",
              "value": "30",
            },
            "35": {
              "color": "maroon",
              "value": "32",
            },
          },
          "160-179": {
            "19": {
              "color": "red",
              "value": "22",
            },
            "20-24": {
              "color": "red",
              "value": "23",
            },
            "25-29": {
              "color": "red",
              "value": "24",
            },
            "30-34": {
              "color": "red",
              "value": "25",
            },
            "35": {
              "color": "red",
              "value": "27",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "18",
            },
            "20-24": {
              "color": "orange",
              "value": "19",
            },
            "25-29": {
              "color": "red",
              "value": "20",
            },
            "30-34": {
              "color": "red",
              "value": "21",
            },
            "35": {
              "color": "red",
              "value": "23",
            },
          },
          "120-139": {
            "19": {
              "color": "orange",
              "value": "15",
            },
            "20-24": {
              "color": "orange",
              "value": "16",
            },
            "25-29": {
              "color": "orange",
              "value": "17",
            },
            "30-34": {
              "color": "orange",
              "value": "18",
            },
            "35": {
              "color": "orange",
              "value": "19",
            },
          },
          "119": {
            "19": {
              "color": "orange",
              "value": "13",
            },
            "20-24": {
              "color": "orange",
              "value": "13",
            },
            "25-29": {
              "color": "orange",
              "value": "14",
            },
            "30-34": {
              "color": "orange",
              "value": "15",
            },
            "35": {
              "color": "orange",
              "value": "16",
            },
          },
        },
        "65-69": {
          "180": {
            "19": {
              "color": "red",
              "value": "21",
            },
            "20-24": {
              "color": "red",
              "value": "22",
            },
            "25-29": {
              "color": "red",
              "value": "24",
            },
            "30-34": {
              "color": "red",
              "value": "25",
            },
            "35": {
              "color": "red",
              "value": "27",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "17",
            },
            "20-24": {
              "color": "orange",
              "value": "18",
            },
            "25-29": {
              "color": "orange",
              "value": "19",
            },
            "30-34": {
              "color": "red",
              "value": "21",
            },
            "35": {
              "color": "red",
              "value": "22",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "14",
            },
            "20-24": {
              "color": "orange",
              "value": "15",
            },
            "25-29": {
              "color": "orange",
              "value": "16",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "orange",
              "value": "18",
            },
          },
          "120-139": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "12",
            },
            "25-29": {
              "color": "orange",
              "value": "13",
            },
            "30-34": {
              "color": "orange",
              "value": "14",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "11",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
        },
        "60-64": {
          "180": {
            "19": {
              "color": "orange",
              "value": "17",
            },
            "20-24": {
              "color": "orange",
              "value": "18",
            },
            "25-29": {
              "color": "orange",
              "value": "19",
            },
            "30-34": {
              "color": "red",
              "value": "21",
            },
            "35": {
              "color": "red",
              "value": "23",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "13",
            },
            "20-24": {
              "color": "orange",
              "value": "14",
            },
            "25-29": {
              "color": "orange",
              "value": "16",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "orange",
              "value": "18",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "12",
            },
            "25-29": {
              "color": "orange",
              "value": "12",
            },
            "30-34": {
              "color": "orange",
              "value": "14",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "9",
            },
            "25-29": {
              "color": "orange",
              "value": "10",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "7",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "9",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          },
        },
        "55-59": {
          "180": {
            "19": {
              "color": "orange",
              "value": "14",
            },
            "20-24": {
              "color": "orange",
              "value": "15",
            },
            "25-29": {
              "color": "orange",
              "value": "16",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "orange",
              "value": "19",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "11",
            },
            "25-29": {
              "color": "orange",
              "value": "12",
            },
            "30-34": {
              "color": "orange",
              "value": "14",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "9",
            },
            "25-29": {
              "color": "orange",
              "value": "10",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "8",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
        },
        "50-54": {
          "180": {
            "19": {
              "color": "orange",
              "value": "11",
            },
            "20-24": {
              "color": "orange",
              "value": "12",
            },
            "25-29": {
              "color": "orange",
              "value": "13",
            },
            "30-34": {
              "color": "orange",
              "value": "14",
            },
            "35": {
              "color": "orange",
              "value": "16",
            },
          },
          "160-179": {
            "19": {
              "color": "yellow",
              "value": "8",
            },
            "20-24": {
              "color": "yellow",
              "value": "9",
            },
            "25-29": {
              "color": "orange",
              "value": "10",
            },
            "30-34": {
              "color": "orange",
              "value": "11",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "7",
            },
            "25-29": {
              "color": "yellow",
              "value": "8",
            },
            "30-34": {
              "color": "yellow",
              "value": "8",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "5",
            },
            "20-24": {
              "color": "yellow",
              "value": "5",
            },
            "25-29": {
              "color": "yellow",
              "value": "6",
            },
            "30-34": {
              "color": "yellow",
              "value": "6",
            },
            "35": {
              "color": "yellow",
              "value": "7",
            },
          },
          "119": {
            "19": {
              "color": "green",
              "value": "4",
            },
            "20-24": {
              "color": "green",
              "value": "4",
            },
            "25-29": {
              "color": "green",
              "value": "4",
            },
            "30-34": {
              "color": "yellow",
              "value": "5",
            },
            "35": {
              "color": "yellow",
              "value": "5",
            },
          }
        },
          "45-49": {
            "180": {
              "19": {
                "color": "yellow",
                "value": "9",
              },
              "20-24": {
                "color": "orange",
                "value": "10",
              },
              "25-29": {
                "color": "orange",
                "value": "11",
              },
              "30-34": {
                "color": "orange",
                "value": "12",
              },
              "35": {
                "color": "orange",
                "value": "13",
              },
            },
            "160-179": {
              "19": {
                "color": "yellow",
                "value": "6",
              },
              "20-24": {
                "color": "yellow",
                "value": "7",
              },
              "25-29": {
                "color": "yellow",
                "value": "8",
              },
              "30-34": {
                "color": "yellow",
                "value": "9",
              },
              "35": {
                "color": "orange",
                "value": "10",
              },
            },
            "140-159": {
              "19": {
                "color": "yellow",
                "value": "5",
              },
              "20-24": {
                "color": "yellow",
                "value": "5",
              },
              "25-29": {
                "color": "yellow",
                "value": "6",
              },
              "30-34": {
                "color": "yellow",
                "value": "7",
              },
              "35": {
                "color": "yellow",
                "value": "7",
              },
            },
            "120-139": {
              "19": {
                "color": "green",
                "value": "3",
              },
              "20-24": {
                "color": "green",
                "value": "4",
              },
              "25-29": {
                "color": "green",
                "value": "4",
              },
              "30-34": {
                "color": "yellow",
                "value": "5",
              },
              "35": {
                "color": "yellow",
                "value": "6",
              },
            },
            "119": {
              "19": {
                "color": "green",
                "value": "3",
              },
              "20-24": {
                "color": "green",
                "value": "3",
              },
              "25-29": {
                "color": "green",
                "value": "3",
              },
              "30-34": {
                "color": "green",
                "value": "4",
              },
              "35": {
                "color": "green",
                "value": "4",
              },
            },
          },
          "40-44": {
            "180": {
              "19": {
                "color": "yellow",
                "value": "7",
              },
              "20-24": {
                "color": "yellow",
                "value": "8",
              },
              "25-29": {
                "color": "yellow",
                "value": "9",
              },
              "30-34": {
                "color": "orange",
                "value": "10",
              },
              "35": {
                "color": "orange",
                "value": "11",
              },
            },
            "160-179": {
              "19": {
                "color": "yellow",
                "value": "5",
              },
              "20-24": {
                "color": "yellow",
                "value": "6",
              },
              "25-29": {
                "color": "yellow",
                "value": "6",
              },
              "30-34": {
                "color": "yellow",
                "value": "7",
              },
              "35": {
                "color": "yellow",
                "value": "8",
              },
            },
            "140-159": {
              "19": {
                "color": "green",
                "value": "4",
              },
              "20-24": {
                "color": "green",
                "value": "4",
              },
              "25-29": {
                "color": "orange",
                "value": "5",
              },
              "30-34": {
                "color": "orange",
                "value": "5",
              },
              "35": {
                "color": "orange",
                "value": "6",
              },
            },
            "120-139": {
              "19": {
                "color": "green",
                "value": "3",
              },
              "20-24": {
                "color": "green",
                "value": "3",
              },
              "25-29": {
                "color": "green",
                "value": "3",
              },
              "30-34": {
                "color": "green",
                "value": "4",
              },
              "35": {
                "color": "green",
                "value": "4",
              },
            },
            "119": {
              "19": {
                "color": "green",
                "value": "2",
              },
              "20-24": {
                "color": "green",
                "value": "2",
              },
              "25-29": {
                "color": "green",
                "value": "2",
              },
              "30-34": {
                "color": "green",
                "value": "3",
              },
              "35": {
                "color": "green",
                "value": "3",
              },
            },
          },
        },
      "smoker": {
        "70-74": {
          "180": {
            "19": {
              "color": "maroon",
              "value": "32",
            },
            "20-24": {
              "color": "maroon",
              "value": "33",
            },
            "25-29": {
              "color": "maroon",
              "value": "35",
            },
            "30-34": {
              "color": "maroon",
              "value": "37",
            },
            "35": {
              "color": "maroon",
              "value": "38",
            },
          },
          "160-179": {
            "19": {
              "color": "red",
              "value": "27",
            },
            "20-24": {
              "color": "red",
              "value": "28",
            },
            "25-29": {
              "color": "maroon",
              "value": "30",
            },
            "30-34": {
              "color": "maroon",
              "value": "31",
            },
            "35": {
              "color": "maroon",
              "value": "33",
            },
          },
          "140-159": {
            "19": {
              "color": "red",
              "value": "22",
            },
            "20-24": {
              "color": "red",
              "value": "24",
            },
            "25-29": {
              "color": "red",
              "value": "25",
            },
            "30-34": {
              "color": "red",
              "value": "26",
            },
            "35": {
              "color": "red",
              "value": "28",
            },
          },
          "120-139": {
            "19": {
              "color": "orange",
              "value": "19",
            },
            "20-24": {
              "color": "red",
              "value": "20",
            },
            "25-29": {
              "color": "red",
              "value": "21",
            },
            "30-34": {
              "color": "red",
              "value": "22",
            },
            "35": {
              "color": "red",
              "value": "23",
            },
          },
          "119": {
            "19": {
              "color": "orange",
              "value": "16",
            },
            "20-24": {
              "color": "orange",
              "value": "17",
            },
            "25-29": {
              "color": "orange",
              "value": "18",
            },
            "30-34": {
              "color": "orange",
              "value": "19",
            },
            "35": {
              "color": "red",
              "value": "20",
            },
          },
        },
        "65-69": {
          "180": {
            "19": {
              "color": "red",
              "value": "27",
            },
            "20-24": {
              "color": "red",
              "value": "29",
            },
            "25-29": {
              "color": "maroon",
              "value": "31",
            },
            "30-34": {
              "color": "maroon",
              "value": "33",
            },
            "35": {
              "color": "maroon",
              "value": "35",
            },
          },
          "160-179": {
            "19": {
              "color": "red",
              "value": "22",
            },
            "20-24": {
              "color": "red",
              "value": "24",
            },
            "25-29": {
              "color": "red",
              "value": "25",
            },
            "30-34": {
              "color": "red",
              "value": "27",
            },
            "35": {
              "color": "red",
              "value": "29",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "18",
            },
            "20-24": {
              "color": "red",
              "value": "20",
            },
            "25-29": {
              "color": "red",
              "value": "21",
            },
            "30-34": {
              "color": "red",
              "value": "22",
            },
            "35": {
              "color": "red",
              "value": "24",
            },
          },
          "120-139": {
            "19": {
              "color": "orange",
              "value": "15",
            },
            "20-24": {
              "color": "orange",
              "value": "16",
            },
            "25-29": {
              "color": "orange",
              "value": "17",
            },
            "30-34": {
              "color": "orange",
              "value": "18",
            },
            "35": {
              "color": "red",
              "value": "20",
            },
          },
          "119": {
            "19": {
              "color": "orange",
              "value": "12",
            },
            "20-24": {
              "color": "orange",
              "value": "13",
            },
            "25-29": {
              "color": "orange",
              "value": "14",
            },
            "30-34": {
              "color": "orange",
              "value": "15",
            },
            "35": {
              "color": "orange",
              "value": "16",
            },
          },
        },
        "60-64": {
          "180": {
            "19": {
              "color": "red",
              "value": "23",
            },
            "20-24": {
              "color": "red",
              "value": "25",
            },
            "25-29": {
              "color": "red",
              "value": "27",
            },
            "30-34": {
              "color": "red",
              "value": "29",
            },
            "35": {
              "color": "maroon",
              "value": "31",
            },
          },
          "160-179": {
            "19": {
              "color": "red",
              "value": "19",
            },
            "20-24": {
              "color": "red",
              "value": "20",
            },
            "25-29": {
              "color": "red",
              "value": "22",
            },
            "30-34": {
              "color": "red",
              "value": "23",
            },
            "35": {
              "color": "red",
              "value": "25",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "15",
            },
            "20-24": {
              "color": "orange",
              "value": "16",
            },
            "25-29": {
              "color": "orange",
              "value": "17",
            },
            "30-34": {
              "color": "orange",
              "value": "19",
            },
            "35": {
              "color": "red",
              "value": "21",
            },
          },
          "120-139": {
            "19": {
              "color": "orange",
              "value": "12",
            },
            "20-24": {
              "color": "orange",
              "value": "13",
            },
            "25-29": {
              "color": "orange",
              "value": "14",
            },
            "30-34": {
              "color": "orange",
              "value": "15",
            },
            "35": {
              "color": "orange",
              "value": "17",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "11",
            },
            "30-34": {
              "color": "orange",
              "value": "12",
            },
            "35": {
              "color": "orange",
              "value": "13",
            },
          },
        },
        "55-59": {
          "180": {
            "19": {
              "color": "red",
              "value": "20",
            },
            "20-24": {
              "color": "red",
              "value": "21",
            },
            "25-29": {
              "color": "red",
              "value": "23",
            },
            "30-34": {
              "color": "red",
              "value": "26",
            },
            "35": {
              "color": "red",
              "value": "28",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "15",
            },
            "20-24": {
              "color": "orange",
              "value": "17",
            },
            "25-29": {
              "color": "orange",
              "value": "18",
            },
            "30-34": {
              "color": "red",
              "value": "20",
            },
            "35": {
              "color": "red",
              "value": "22",
            },
          },
          "140-159": {
            "19": {
              "color": "yellow",
              "value": "12",
            },
            "20-24": {
              "color": "yellow",
              "value": "13",
            },
            "25-29": {
              "color": "yellow",
              "value": "15",
            },
            "30-34": {
              "color": "yellow",
              "value": "16",
            },
            "35": {
              "color": "yellow",
              "value": "18",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "9",
            },
            "20-24": {
              "color": "orange",
              "value": "10",
            },
            "25-29": {
              "color": "orange",
              "value": "11",
            },
            "30-34": {
              "color": "orange",
              "value": "13",
            },
            "35": {
              "color": "orange",
              "value": "14",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "7",
            },
            "20-24": {
              "color": "yellow",
              "value": "8",
            },
            "25-29": {
              "color": "yellow",
              "value": "9",
            },
            "30-34": {
              "color": "orange",
              "value": "10",
            },
            "35": {
              "color": "orange",
              "value": "11",
            },
          },
        },
        "50-54": {
          "180": {
            "19": {
              "color": "orange",
              "value": "17",
            },
            "20-24": {
              "color": "orange",
              "value": "18",
            },
            "25-29": {
              "color": "red",
              "value": "20",
            },
            "30-34": {
              "color": "red",
              "value": "23",
            },
            "35": {
              "color": "red",
              "value": "25",
            },
          },
          "160-179": {
            "19": {
              "color": "orange",
              "value": "13",
            },
            "20-24": {
              "color": "orange",
              "value": "14",
            },
            "25-29": {
              "color": "orange",
              "value": "16",
            },
            "30-34": {
              "color": "orange",
              "value": "17",
            },
            "35": {
              "color": "orange",
              "value": "19",
            },
          },
          "140-159": {
            "19": {
              "color": "orange",
              "value": "10",
            },
            "20-24": {
              "color": "orange",
              "value": "11",
            },
            "25-29": {
              "color": "orange",
              "value": "12",
            },
            "30-34": {
              "color": "orange",
              "value": "13",
            },
            "35": {
              "color": "orange",
              "value": "15",
            },
          },
          "120-139": {
            "19": {
              "color": "yellow",
              "value": "7",
            },
            "20-24": {
              "color": "yellow",
              "value": "8",
            },
            "25-29": {
              "color": "yellow",
              "value": "9",
            },
            "30-34": {
              "color": "orange",
              "value": "10",
            },
            "35": {
              "color": "orange",
              "value": "12",
            },
          },
          "119": {
            "19": {
              "color": "yellow",
              "value": "6",
            },
            "20-24": {
              "color": "yellow",
              "value": "6",
            },
            "25-29": {
              "color": "yellow",
              "value": "7",
            },
            "30-34": {
              "color": "yellow",
              "value": "8",
            },
            "35": {
              "color": "yellow",
              "value": "9",
            },
          }
        },
        "45-49": {
            "180": {
              "19": {
                "color": "orange",
                "value": "14",
              },
              "20-24": {
                "color": "orange",
                "value": "16",
              },
              "25-29": {
                "color": "orange",
                "value": "18",
              },
              "30-34": {
                "color": "red",
                "value": "20",
              },
              "35": {
                "color": "red",
                "value": "22",
              },
            },
            "160-179": {
              "19": {
                "color": "orange",
                "value": "11",
              },
              "20-24": {
                "color": "orange",
                "value": "12",
              },
              "25-29": {
                "color": "orange",
                "value": "13",
              },
              "30-34": {
                "color": "orange",
                "value": "15",
              },
              "35": {
                "color": "orange",
                "value": "17",
              },
            },
            "140-159": {
              "19": {
                "color": "yellow",
                "value": "8",
              },
              "20-24": {
                "color": "yellow",
                "value": "9",
              },
              "25-29": {
                "color": "orange",
                "value": "10",
              },
              "30-34": {
                "color": "orange",
                "value": "11",
              },
              "35": {
                "color": "orange",
                "value": "13",
              },
            },
            "120-139": {
              "19": {
                "color": "yellow",
                "value": "6",
              },
              "20-24": {
                "color": "yellow",
                "value": "7",
              },
              "25-29": {
                "color": "yellow",
                "value": "7",
              },
              "30-34": {
                "color": "yellow",
                "value": "8",
              },
              "35": {
                "color": "yellow",
                "value": "10",
              },
            },
            "119": {
              "19": {
                "color": "green",
                "value": "4",
              },
              "20-24": {
                "color": "yellow",
                "value": "5",
              },
              "25-29": {
                "color": "yellow",
                "value": "6",
              },
              "30-34": {
                "color": "yellow",
                "value": "6",
              },
              "35": {
                "color": "yellow",
                "value": "7",
              },
            },
           },
          "40-44": {
            "180": {
              "19": {
                "color": "orange",
                "value": "12",
              },
              "20-24": {
                "color": "orange",
                "value": "13",
              },
              "25-29": {
                "color": "orange",
                "value": "15",
              },
              "30-34": {
                "color": "orange",
                "value": "17",
              },
              "35": {
                "color": "red",
                "value": "20",
              },
            },
            "160-179": {
              "19": {
                "color": "yellow",
                "value": "9",
              },
              "20-24": {
                "color": "orange",
                "value": "10",
              },
              "25-29": {
                "color": "orange",
                "value": "11",
              },
              "30-34": {
                "color": "orange",
                "value": "13",
              },
              "35": {
                "color": "orange",
                "value": "15",
              },
            },
            "140-159": {
              "19": {
                "color": "yellow",
                "value": "6",
              },
              "20-24": {
                "color": "yellow",
                "value": "7",
              },
              "25-29": {
                "color": "yellow",
                "value": "8",
              },
              "30-34": {
                "color": "yellow",
                "value": "9",
              },
              "35": {
                "color": "orange",
                "value": "11",
              },
            },
            "120-139": {
              "19": {
                "color": "yellow",
                "value": "5",
              },
              "20-24": {
                "color": "yellow",
                "value": "5",
              },
              "25-29": {
                "color": "yellow",
                "value": "6",
              },
              "30-34": {
                "color": "yellow",
                "value": "7",
              },
              "35": {
                "color": "yellow",
                "value": "8",
              },
            },
            "119": {
              "19": {
                "color": "green",
                "value": "3",
              },
              "20-24": {
                "color": "green",
                "value": "4",
              },
              "25-29": {
                "color": "green",
                "value": "4",
              },
              "30-34": {
                "color": "yellow",
                "value": "5",
              },
              "35": {
                "color": "yellow",
                "value": "6",
              },
            },
          },
        },
    },
  }
